import { AllReportsPage } from './AllReports';
import { createAllReportsHandle } from './handle';

export default {
  Component: AllReportsPage,
  createHandle: createAllReportsHandle
};
